
import {useState} from 'react';
import { json, useParams,Link } from 'react-router-dom'
import { useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import api from './api/posts';
import SelectedImages from './SelectedImages'
import { APISERVERURL } from './APIServerURL';
import Spinner from 'react-bootstrap/Spinner';

function EditPost({posts,setPosts,accessToken,setAccessToken,villages}) {
  const [isLoading,setIsloading]=useState(false);
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [activity, setActivity] = useState('');
  const [outcome, setOutcome] = useState('');
  const [storedImages, setStoredImages] = useState([]);
  const [images,setImages]=useState([]);

  const navigate=useNavigate();

  const {id}=useParams();
  
  const post=posts.find((post)=>{
      return (post._id.toString()===id.toString());
  })
  
  let ui=``;
  
  useEffect(()=>{
       if(post)
          {
            setFromTime(post.fromTime);
            setToTime(post.toTime);
            setActivity(post.activity);
            setOutcome(post.outcome);
            setStoredImages(post.images);
          }
  },[post])
  
  function addToImageList(selectedFiles)
  {
    const newImages=[...images,...selectedFiles];
    /*for(let i=0;i<selectedFiles.length;i++)
      {
        let j=0;
        for(j=0;j<images.length;j++)
          {
              if(images[j].name===selectedFiles[i].name)
                {
                  console.log(selectedFiles[i].name);
                  break;
                }
          }
        if(j===images.length)
          {
            newImages.push(selectedFiles[i]);
          }        
      }
          */
      setImages(newImages);
      console.log(newImages.length);
  }

  function getUID()
  {
     let timestamp=Date.now();
     return timestamp.toString(36);
  }
  const handleUpdate=async (e)=>
  {
      e.preventDefault();
      let formData = new FormData();    //formdata object

      formData.append("fromTime",fromTime); 
      formData.append("toTime",toTime);

      formData.append("activity", activity);
      formData.append("outcome", outcome);
      formData.append("id", id);
      Object.values(images).forEach(file=>{
        formData.append("images", file);
      });
      const config = {     
          headers: { 'content-type': 'multipart/form-data' }
      }
      setIsloading(true);
     try{
      const response= await api.put('/employees',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
      setPosts(response.data);
      setIsloading(false);
      navigate(`/post/${id}`)
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await api.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          try{       
            const response= await api.put('/employees',formData,{headers:{'Authorization':`Bearer ${nat}`}}); 
            setPosts(response.data);   
            setIsloading(false);  
            navigate(`/post/${id}`)
           }
           catch(err)
           {
            alert('unusual error edit.js');
            setIsloading(false);
            //navigate('/');
           }
        }
        catch(err)
        {
          alert('failed');
          setIsloading(false);
          //setError(JSON.stringify(err));
          //navigate('/');
        }

      }  
    }
    async function deletePhoto(e,img,postId)
    {
      e.preventDefault();
      try{
        //alert(img+" "+postId);
        //post request to deletePhoto wit {id,fileName}
        const response= await api.post('/employees/deletePhoto',{id:postId,fileName:img},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        setPosts(response.data);
        //navigate(`/edit/${postId}`); 
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await api.get('/getAccessToken',config);
          //alert(JSON.stringify(x['data']['accessToken']));
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          //console.log(`ne at ${nat}`);
          //console.log(`Second at:${accessToken}`);
          try{       
            const response= await api.post('/employees/deletePhoto',{id:postId,fileName:img},{headers:{'Authorization':`Bearer ${nat}`}});    
            setPosts(response.data);
            //navigate(`/edit/${postId}`); 
           }
           catch(err)
           {
            alert('unusual error newposts.js');
            //navigate('/');
           }
        }
        catch(err)
        {
          alert('failed');
          //setError(JSON.stringify(err));
          //navigate('/');
        }

      }
    }

    let uimges=``;
    if(storedImages && storedImages.length!==0)
      {
          uimges=storedImages.map((image,index)=>{
          return      <div className='imgThumbHome2' key={index}>
                        <img  src={`${APISERVERURL}/img/${image}`} alt="placeholder" />
                        <button className='btn btn-danger btnEditTxDetails' onClick={(e)=>{deletePhoto(e,image,id)}}>REMOVE IMAGE</button>
                        </div>
         })
      }
      else{
          uimges=<p>
          {"0 photosaaaa"}
          </p>
      }
    return (
      <main>
         <div className="fullWidth centeredDiv"><h3>Edit Activity</h3></div>
        <form className='newPost' onSubmit={handleUpdate}>

        <label className="marginTop" htmlFor='txtFromTime'>From Time:</label>
        <input 
        type='text' className="borderLess"
        id='txtFromTime'
        required
        value={fromTime}
        onChange={(e)=>{setFromTime(e.target.value)}}
        />
        <label className="marginTop" htmlFor='txtToTime'>To Time:</label>
        <input 
        type='text' className="borderLess"
        id='txtToTime'
        required
        value={toTime}
        onChange={(e)=>{setToTime(e.target.value)}}
        />
        <label className="marginTop" htmlFor='txtActivity'>Activity:</label>
        <textarea 
          className="borderLess"
          id='txtActivity'
          required
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
        ></textarea>

        <label className="marginTop" htmlFor='txtOutcome'>Outcome:</label>
        <textarea 
          className="borderLess"
          id='txtOutcome'
          required
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
        ></textarea>
        
        <div className='marginTopm'>
          <p>
            Uploaded Photos 
          </p> 
          <div className='album'>
            {uimges}
          </div>
        </div>
        <div className='marginTopm'>
          <label htmlFor="fuPhotos" className="custom-file-label">
            Select more Images: 
          </label>
          <input
            className="file-input-hidden"
            type="file"
            id="fuPhotos"
            name="uploadedPhotos"
            multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e) => {
              addToImageList(e.target.files);
            }}
          />
      </div>
      <SelectedImages
      images={images}
      setImages={setImages}
      >
      </SelectedImages>  
        <div className="secondaryNav marginTop">
            <Link to={`/`}><button className='btn btn-success' style={{fontSize:'13px', letterSpacing:'1.1px'}}>HOME</button></Link>
            <button className='btn btn-primary' type='submit' style={{fontSize:'13px', letterSpacing:'1.1px'}}>UPDATE</button>
        </div>
        </form>
        {isLoading && 
        <div className='spinneroverlay'>
          <div className='spinnerbody'>
            <Spinner animation="border" variant="info" />
            <p>Please wait. It might take a few seconds.</p>
          </div>           
        </div>}
      </main>
    )
  }
  
  export default EditPost